// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__mVIYM","input":"Search_input__klILD","icon":"Search_icon__XMmYc"};